<div class="min-h-screen dark:bg-slate-900 p-4 md:p-8 text-sm text-slate-600 dark:text-slate-300">
  <!-- LIST -->
  <ng-container *ngIf="viewMode() === 'list'">
    <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
      <div>
        <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight flex items-center gap-3">
          <span class="w-11 h-11 rounded-2xl bg-gradient-to-br from-amber-400 to-amber-500 text-slate-900 inline-flex items-center justify-center shadow-[0_8px_20px_-6px_rgba(251,191,36,0.55)]">
            <span class="material-icons">menu_book</span>
          </span>
          คู่มือสาธารณะ
        </h1>
        <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
          จัดการคู่มือสำหรับหน้า LIFF
          <code class="bg-slate-100 dark:bg-slate-800 px-1.5 py-0.5 rounded text-xs">/manual/guides</code>
        </p>
      </div>
      <div class="flex flex-col sm:flex-row sm:items-center gap-3 self-start md:self-end">
        <div class="inline-flex items-center gap-2 h-[46px] pl-3 pr-1.5 rounded-2xl bg-white/95 dark:bg-slate-800/95 border border-slate-100/50 dark:border-slate-700 shadow-sm">
          <div class="flex flex-col justify-center min-w-[7.5rem] pr-1 border-r border-slate-100 dark:border-slate-700">
            <span class="text-[10px] text-slate-400 dark:text-slate-500 font-medium leading-none mb-1 whitespace-nowrap">ดึงข้อมูลล่าสุด</span>
            <span class="text-[13px] font-bold leading-none tabular-nums"
              [class.text-slate-600]="lastFetchedTime()"
              [class.dark:text-slate-300]="lastFetchedTime()"
              [class.text-slate-300]="!lastFetchedTime()"
              [class.dark:text-slate-600]="!lastFetchedTime()">
              {{ lastFetchedTime() ? (lastFetchedTime() | date:'HH:mm:ss') : '--:--:--' }}
            </span>
          </div>
          <button type="button" (click)="reload()" [disabled]="isLoading() || isSaving()" title="โหลดข้อมูลใหม่"
            class="w-9 h-9 rounded-xl text-slate-500 hover:text-amber-500 hover:bg-amber-50 dark:hover:bg-amber-900/20 transition-all flex items-center justify-center disabled:opacity-40 cursor-pointer">
            <span class="material-icons text-[20px]" [class.animate-spin]="isLoading()">refresh</span>
          </button>
        </div>
        <button *ngIf="canUpdate || canCreate" type="button" (click)="openContact()"
          class="px-4 h-[46px] bg-white/95 dark:bg-slate-800/95 text-slate-600 dark:text-slate-300 font-bold rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800 transition-all flex items-center justify-center gap-2 cursor-pointer">
          <span class="material-icons text-[18px]">support_agent</span>
          แจ้งปัญหา / ติดต่อ
        </button>
        <button *ngIf="canCreate" type="button" (click)="openCreate()"
          class="px-5 h-[46px] bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold rounded-2xl shadow-lg shadow-amber-200/50 dark:shadow-none transition-all flex items-center justify-center gap-2 cursor-pointer border-none">
          <span class="material-icons text-[18px]">add</span>
          สร้างคู่มือ
        </button>
      </div>
    </div>

    <div class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.04)] border border-slate-100/50 dark:border-slate-700/50 overflow-hidden relative">
      <div class="p-6 border-b border-slate-100/70 dark:border-slate-700 flex flex-col lg:flex-row lg:items-center justify-between gap-4">
        <div>
          <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
            <span class="material-icons text-amber-500">menu_book</span>
            รายการคู่มือ
          </h3>
          <p class="text-xs text-slate-400 mt-1">รูปตอบเป็น base64 — ไม่โชว์ URL CDN</p>
        </div>
        <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full lg:w-auto">
          <select [(ngModel)]="filterKind" (ngModelChange)="onSearch()"
            class="px-3 py-2.5 bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200 cursor-pointer">
            <option value="">ประเภททั้งหมด</option>
            <option *ngFor="let k of kindOptions" [value]="k.value">{{ k.label }}</option>
          </select>
          <select [(ngModel)]="filterPublished" (ngModelChange)="onSearch()"
            class="px-3 py-2.5 bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200 cursor-pointer">
            <option value="">เผยแพร่ทั้งหมด</option>
            <option value="true">เผยแพร่แล้ว</option>
            <option value="false">ยังไม่เผยแพร่</option>
          </select>
          <select [(ngModel)]="filterActive" (ngModelChange)="onSearch()"
            class="px-3 py-2.5 bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200 cursor-pointer">
            <option value="">สถานะทั้งหมด</option>
            <option value="true">ใช้งาน</option>
            <option value="false">ปิดใช้</option>
          </select>
          <div class="relative w-full sm:w-72">
            <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px]">search</span>
            <input type="text" [(ngModel)]="searchText" (keyup.enter)="onSearch()" placeholder="ค้นหาหัวข้อ / slug..."
              class="w-full pl-10 pr-4 py-2.5 bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-medium focus:ring-2 focus:ring-amber-200 focus:outline-none" />
          </div>
        </div>
      </div>

      <div class="overflow-x-auto min-h-[300px] relative custom-scrollbar">
        <table class="w-full text-left border-collapse"
          [class.opacity-50]="isLoading()" [class.pointer-events-none]="isLoading()">
          <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 border-b border-slate-100 dark:border-slate-700">
            <tr class="text-xs font-bold text-slate-400 uppercase tracking-widest">
              <th class="p-4 w-20">ปก</th>
              <th class="p-4">หัวข้อ</th>
              <th class="p-4">ประเภท</th>
              <th class="p-4">Slug</th>
              <th class="p-4 text-center">บล็อก</th>
              <th class="p-4 text-center">สถานะ</th>
              <th class="p-4 text-center w-[120px]">จัดการ</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
            <tr *ngFor="let item of items(); trackBy: trackById"
              class="hover:bg-slate-50/60 dark:hover:bg-slate-700/40 transition-all">
              <td class="p-4">
                <button *ngIf="item.coverImage; else noCover" type="button" (click)="openImageModal(item.coverImage!)"
                  class="w-14 h-10 rounded-xl overflow-hidden border border-slate-100 dark:border-slate-700 p-0 bg-slate-100 dark:bg-slate-900">
                  <img [src]="item.coverImage" alt="" class="w-full h-full object-cover" />
                </button>
                <ng-template #noCover>
                  <div class="w-14 h-10 rounded-xl bg-slate-100 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 flex items-center justify-center">
                    <span class="material-icons text-slate-300 text-base">image</span>
                  </div>
                </ng-template>
              </td>
              <td class="p-4">
                <p class="font-bold text-slate-700 dark:text-slate-200">{{ item.titleTh || '—' }}</p>
                <p *ngIf="item.summaryTh" class="text-xs text-slate-400 mt-0.5 line-clamp-1">{{ item.summaryTh }}</p>
              </td>
              <td class="p-4">
                <span class="inline-flex px-2.5 py-1 rounded-full text-[10px] font-bold"
                  [ngClass]="item.guideKind === 'ev'
                    ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400'
                    : 'bg-sky-50 text-sky-700 dark:bg-sky-900/30 dark:text-sky-400'">
                  {{ kindLabel(item.guideKind) }}
                </span>
              </td>
              <td class="p-4 font-mono text-xs font-bold text-slate-400">{{ item.slug || '—' }}</td>
              <td class="p-4 text-center">
                <span class="inline-flex min-w-[2rem] justify-center px-2.5 py-1 rounded-full text-xs font-bold bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400">
                  {{ item.blockCount }}
                </span>
              </td>
              <td class="p-4 text-center">
                <div class="inline-flex flex-col gap-1 items-center">
                  <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-bold"
                    [ngClass]="item.isPublished
                      ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400'
                      : 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400'">
                    {{ item.isPublished ? 'เผยแพร่' : 'ร่าง' }}
                  </span>
                  <span *ngIf="!item.isActive"
                    class="inline-flex px-2.5 py-1 rounded-full text-xs font-bold bg-rose-50 text-rose-600 dark:bg-rose-900/30 dark:text-rose-400">
                    ปิดใช้
                  </span>
                </div>
              </td>
              <td class="p-4 text-center whitespace-nowrap">
                <button *ngIf="canUpdate" type="button" (click)="openEdit(item)" title="แก้ไข"
                  class="w-9 h-9 rounded-lg inline-flex items-center justify-center border border-slate-100 dark:border-slate-700 text-slate-400 hover:border-amber-400 hover:text-amber-500 transition-all cursor-pointer mr-1">
                  <span class="material-icons text-base">edit</span>
                </button>
                <button *ngIf="canDelete" type="button" (click)="askDelete(item)" title="ลบ"
                  class="w-9 h-9 rounded-lg inline-flex items-center justify-center border border-slate-100 dark:border-slate-700 text-slate-400 hover:border-rose-400 hover:text-rose-500 transition-all cursor-pointer">
                  <span class="material-icons text-base">delete</span>
                </button>
              </td>
            </tr>
            <tr *ngIf="!isLoading() && items().length === 0">
              <td colspan="7" class="py-20 text-center text-slate-400">
                <span class="material-icons text-4xl mb-2 opacity-40 block">menu_book</span>
                <p class="font-bold">ยังไม่มีคู่มือ</p>
                <p class="text-xs mt-1">กด “สร้างคู่มือ” เพื่อเริ่มต้น</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="px-6 py-4 border-t border-slate-100/70 dark:border-slate-700 flex flex-col md:flex-row items-center justify-between gap-4">
        <div class="flex items-center gap-4 text-sm text-slate-500 font-medium">
          <span>แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalCount() | number }} รายการ</span>
          <select (change)="onPageSizeChange($event)" [ngModel]="pageSize()"
            class="bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-lg font-bold px-2 py-1 outline-none focus:ring-2 focus:ring-amber-200 cursor-pointer">
            <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / หน้า</option>
          </select>
        </div>
        <div class="flex items-center gap-2">
          <button type="button" (click)="onPageChange(page() - 1)" [disabled]="page() <= 1"
            class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all cursor-pointer">
            <span class="material-icons text-sm">chevron_left</span>
          </button>
          <button type="button" *ngFor="let p of pagesArray" (click)="onPageChange(p)"
            class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all cursor-pointer"
            [ngClass]="p === page() ? 'bg-amber-400 text-white shadow-sm' : 'text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700'">
            {{ p }}
          </button>
          <button type="button" (click)="onPageChange(page() + 1)"
            [disabled]="page() >= totalPages || totalPages === 0"
            class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all cursor-pointer">
            <span class="material-icons text-sm">chevron_right</span>
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- EDIT / CREATE -->
  <ng-container *ngIf="viewMode() === 'edit'">
    <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
      <div>
        <button type="button" (click)="backToList()"
          class="mb-2 inline-flex items-center gap-1 text-xs font-bold text-slate-400 hover:text-amber-600 transition-colors">
          <span class="material-icons text-[16px]">arrow_back</span>
          กลับรายการ
        </button>
        <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight flex items-center gap-3">
          <span class="w-11 h-11 rounded-2xl bg-gradient-to-br from-amber-400 to-amber-500 text-slate-900 inline-flex items-center justify-center shadow-[0_8px_20px_-6px_rgba(251,191,36,0.55)]">
            <span class="material-icons">{{ draft().id ? 'edit_note' : 'add_circle' }}</span>
          </span>
          {{ draft().id ? 'แก้ไขคู่มือ' : 'สร้างคู่มือ' }}
        </h1>
        <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
          ตั้งหัวข้อ รูปปก และบล็อกเนื้อหา (ข้อความ / รูป / YouTube)
        </p>
      </div>
      <div class="flex flex-wrap items-center gap-3 self-start md:self-end">
        <button *ngIf="canShowActivityHistory" type="button" (click)="openHistory()"
          class="px-4 h-[46px] bg-white/95 dark:bg-slate-800/95 text-slate-600 dark:text-slate-300 font-bold rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800 transition-all flex items-center justify-center gap-2">
          <span class="material-icons text-[18px]">history</span>
          ดูประวัติ
        </button>
        <button type="button" (click)="backToList()" [disabled]="isSaving()"
          class="px-5 h-[46px] bg-white/95 dark:bg-slate-800/95 text-slate-600 dark:text-slate-300 font-bold rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:bg-slate-50 transition-all disabled:opacity-40">
          ยกเลิก
        </button>
        <button type="button" (click)="onSave()" [disabled]="isSaving() || isLoading()"
          class="px-6 h-[46px] bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold rounded-2xl shadow-lg shadow-amber-200/50 dark:shadow-none transition-all flex items-center justify-center gap-2 disabled:opacity-40 border-none">
          <span class="material-icons text-[18px]">{{ isSaving() ? 'hourglass_top' : 'save' }}</span>
          {{ isSaving() ? 'กำลังบันทึก...' : 'บันทึก' }}
        </button>
      </div>
    </div>

    <div class="relative space-y-6 animate-fade-in">
      <!-- Meta -->
      <section class="bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-xl border border-slate-100/50 dark:border-slate-700 p-6 md:p-8 space-y-5">
        <div class="rounded-xl border border-sky-200 bg-sky-50/70 dark:bg-sky-950/20 p-3 text-sm text-sky-900 dark:text-sky-100">
          กรอกหัวข้อและ slug ให้ครบ — slug ใช้ใน URL ของหน้า LIFF
        </div>

        <h2 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">title</span>
          ข้อมูลหัวข้อ
        </h2>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ประเภทคู่มือ <span class="text-rose-500">*</span></label>
            <select
              class="w-full h-[46px] px-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-bold outline-none focus:ring-2 focus:ring-amber-200 cursor-pointer"
              [ngModel]="draft().guideKind"
              (ngModelChange)="patchDraft({ guideKind: $event })"
              [ngModelOptions]="{ standalone: true }">
              <option *ngFor="let k of kindOptions" [value]="k.value">{{ k.label }}</option>
            </select>
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ลำดับ</label>
            <input type="number"
              class="w-full h-[46px] px-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-bold outline-none focus:ring-2 focus:ring-amber-200"
              [ngModel]="draft().sortOrder" (ngModelChange)="patchDraft({ sortOrder: +$event || 0 })" [ngModelOptions]="{ standalone: true }" />
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">หัวข้อ (TH) <span class="text-rose-500">*</span></label>
            <input
              class="w-full h-[46px] px-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium outline-none focus:ring-2 focus:ring-amber-200"
              [ngModel]="draft().titleTh" (ngModelChange)="onTitleChange($event)" [ngModelOptions]="{ standalone: true }"
              placeholder="เช่น วิธีสมัครบัตรรายเดือน" />
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">หัวข้อ (EN)</label>
            <input
              class="w-full h-[46px] px-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium outline-none focus:ring-2 focus:ring-amber-200"
              [ngModel]="draft().titleEn" (ngModelChange)="patchDraft({ titleEn: $event })" [ngModelOptions]="{ standalone: true }" />
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Slug (URL) <span class="text-rose-500">*</span></label>
            <input
              class="w-full h-[46px] px-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 font-mono text-xs outline-none focus:ring-2 focus:ring-amber-200"
              [ngModel]="draft().slug" (ngModelChange)="patchDraft({ slug: $event })" [ngModelOptions]="{ standalone: true }"
              placeholder="how-to-monthly" />
          </div>
          <div class="md:col-span-2">
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">สรุปสั้น</label>
            <textarea rows="2"
              class="w-full px-4 py-2.5 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm outline-none focus:ring-2 focus:ring-amber-200 resize-none"
              [ngModel]="draft().summaryTh" (ngModelChange)="patchDraft({ summaryTh: $event })" [ngModelOptions]="{ standalone: true }"></textarea>
          </div>
          <div class="flex flex-wrap items-center gap-6 md:col-span-2">
            <label class="inline-flex items-center gap-2 cursor-pointer select-none">
              <input type="checkbox" class="rounded border-slate-300 text-amber-500 focus:ring-amber-400"
                [ngModel]="draft().isPublished"
                (ngModelChange)="patchDraft({ isPublished: $event })" [ngModelOptions]="{ standalone: true }" />
              <span class="font-bold text-slate-700 dark:text-slate-200">เผยแพร่บน /manual</span>
            </label>
            <label class="inline-flex items-center gap-2 cursor-pointer select-none">
              <input type="checkbox" class="rounded border-slate-300 text-amber-500 focus:ring-amber-400"
                [ngModel]="draft().isActive"
                (ngModelChange)="patchDraft({ isActive: $event })" [ngModelOptions]="{ standalone: true }" />
              <span class="font-bold text-slate-700 dark:text-slate-200">ใช้งาน</span>
            </label>
          </div>
        </div>

        <div class="pt-2 border-t border-slate-100 dark:border-slate-800">
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-3">รูปปก (optional)</label>
          <div class="flex flex-wrap items-start gap-4">
            <button *ngIf="coverSrc(draft())" type="button" (click)="openImageModal(coverSrc(draft()))"
              class="w-44 h-28 rounded-2xl overflow-hidden border border-slate-100 dark:border-slate-700 p-0 shadow-sm">
              <img [src]="coverSrc(draft())" alt="" class="w-full h-full object-cover" />
            </button>
            <div *ngIf="!coverSrc(draft())"
              class="w-44 h-28 rounded-2xl border border-dashed border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/50 flex flex-col items-center justify-center text-slate-400">
              <span class="material-icons mb-1">image</span>
              <span class="text-[11px] font-bold">ยังไม่มีรูปปก</span>
            </div>
            <div class="space-y-2">
              <label class="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-amber-50 dark:bg-amber-900/20 text-amber-800 dark:text-amber-300 border border-amber-100 dark:border-amber-800/50 font-bold text-xs cursor-pointer hover:bg-amber-100/80 transition-colors">
                <span class="material-icons text-[16px]">image</span>
                เลือกรูปปก
                <input type="file" accept="image/*" class="hidden" (change)="onCoverSelected($event)" />
              </label>
              <button *ngIf="coverSrc(draft())" type="button" (click)="clearCover()"
                class="block text-xs font-bold text-rose-500 hover:underline">ลบรูปปก</button>
              <p class="text-[11px] text-slate-400">รองรับไฟล์รูป ไม่เกิน 10MB</p>
            </div>
          </div>
        </div>
      </section>

      <!-- Blocks -->
      <section class="bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-xl border border-slate-100/50 dark:border-slate-700 p-6 md:p-8 space-y-4">
        <div class="flex flex-wrap items-center justify-between gap-3">
          <h2 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
            <span class="material-icons text-amber-500">view_agenda</span>
            บล็อกเนื้อหา
          </h2>
          <div class="flex flex-wrap gap-2">
            <button type="button" (click)="addBlock('text')"
              class="px-3 py-2 rounded-xl text-xs font-bold bg-amber-400 hover:bg-amber-500 text-slate-900 border-none shadow-sm transition-all flex items-center gap-1">
              <span class="material-icons text-[16px]">notes</span> ข้อความ
            </button>
            <button type="button" (click)="addBlock('image')"
              class="px-3 py-2 rounded-xl text-xs font-bold bg-slate-100 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 hover:border-amber-300 hover:text-amber-700 transition-all flex items-center gap-1">
              <span class="material-icons text-[16px]">image</span> รูป
            </button>
            <button type="button" (click)="addBlock('youtube')"
              class="px-3 py-2 rounded-xl text-xs font-bold bg-slate-100 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 hover:border-amber-300 hover:text-amber-700 transition-all flex items-center gap-1">
              <span class="material-icons text-[16px]">smart_display</span> YouTube
            </button>
          </div>
        </div>

        <div *ngFor="let block of draft().blocks; let i = index; trackBy: trackByBlock"
          class="rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50/80 dark:bg-slate-800/40 p-4 md:p-5 space-y-3">
          <div class="flex flex-wrap items-center justify-between gap-2">
            <div class="flex items-center gap-2">
              <span class="inline-flex w-8 h-8 items-center justify-center rounded-lg bg-amber-50 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300 text-xs font-black">{{ i + 1 }}</span>
              <select
                class="h-[40px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 text-xs font-bold outline-none focus:ring-2 focus:ring-amber-200"
                [ngModel]="block.blockType"
                (ngModelChange)="patchBlock(i, { blockType: $event })"
                [ngModelOptions]="{ standalone: true }">
                <option *ngFor="let opt of blockTypeOptions" [value]="opt.value">{{ opt.label }}</option>
              </select>
            </div>
            <div class="flex gap-1">
              <button type="button" (click)="moveBlock(i, -1)" title="ขึ้น"
                class="w-9 h-9 rounded-lg inline-flex items-center justify-center border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-400 hover:text-amber-500 transition-all">
                <span class="material-icons text-base">arrow_upward</span>
              </button>
              <button type="button" (click)="moveBlock(i, 1)" title="ลง"
                class="w-9 h-9 rounded-lg inline-flex items-center justify-center border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-400 hover:text-amber-500 transition-all">
                <span class="material-icons text-base">arrow_downward</span>
              </button>
              <button type="button" (click)="removeBlock(i)" title="ลบ"
                class="w-9 h-9 rounded-lg inline-flex items-center justify-center border border-rose-100 dark:border-rose-900/40 bg-rose-50 dark:bg-rose-900/20 text-rose-500 hover:bg-rose-100 transition-all">
                <span class="material-icons text-base">delete</span>
              </button>
            </div>
          </div>

          <ng-container [ngSwitch]="block.blockType">
            <div *ngSwitchCase="'text'">
              <label class="block text-[10px] font-bold text-slate-400 uppercase mb-1">ข้อความ</label>
              <textarea rows="3" placeholder="ข้อความอธิบาย..."
                class="w-full px-3 py-2.5 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 outline-none focus:ring-2 focus:ring-amber-200"
                [ngModel]="block.bodyTh" (ngModelChange)="patchBlock(i, { bodyTh: $event })" [ngModelOptions]="{ standalone: true }"></textarea>
            </div>

            <div *ngSwitchCase="'image'" class="space-y-3">
              <div class="flex flex-wrap gap-3 items-start">
                <button *ngIf="blockSrc(block)" type="button" (click)="openImageModal(blockSrc(block))"
                  class="w-40 h-28 rounded-2xl overflow-hidden border border-slate-100 dark:border-slate-700 p-0 shadow-sm">
                  <img [src]="blockSrc(block)" alt="" class="w-full h-full object-cover" />
                </button>
                <div *ngIf="!blockSrc(block)"
                  class="w-40 h-28 rounded-2xl border border-dashed border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 flex items-center justify-center text-slate-300">
                  <span class="material-icons">image</span>
                </div>
                <div class="space-y-2">
                  <label class="inline-flex items-center gap-2 px-3 py-2 rounded-xl bg-amber-50 dark:bg-amber-900/20 text-amber-800 dark:text-amber-300 border border-amber-100 dark:border-amber-800/50 font-bold text-xs cursor-pointer">
                    <span class="material-icons text-[16px]">upload</span>
                    เลือกรูป
                    <input type="file" accept="image/*" class="hidden" (change)="onBlockImageSelected(i, $event)" />
                  </label>
                  <button *ngIf="blockSrc(block)" type="button" (click)="clearBlockImage(i)"
                    class="block text-xs font-bold text-rose-500 hover:underline">ลบรูป</button>
                </div>
              </div>
              <div>
                <label class="block text-[10px] font-bold text-slate-400 uppercase mb-1">คำบรรยายรูป</label>
                <input placeholder="optional"
                  class="w-full h-[42px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 outline-none focus:ring-2 focus:ring-amber-200"
                  [ngModel]="block.bodyTh" (ngModelChange)="patchBlock(i, { bodyTh: $event })" [ngModelOptions]="{ standalone: true }" />
              </div>
            </div>

            <div *ngSwitchCase="'youtube'" class="space-y-3">
              <div>
                <label class="block text-[10px] font-bold text-slate-400 uppercase mb-1">ลิงก์ YouTube</label>
                <input placeholder="https://www.youtube.com/watch?v=..."
                  class="w-full h-[42px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 outline-none focus:ring-2 focus:ring-amber-200"
                  [ngModel]="block.youtubeUrl" (ngModelChange)="patchBlock(i, { youtubeUrl: $event })" [ngModelOptions]="{ standalone: true }" />
              </div>
              <div>
                <label class="block text-[10px] font-bold text-slate-400 uppercase mb-1">ป้ายปุ่ม / คำอธิบาย</label>
                <input placeholder="optional"
                  class="w-full h-[42px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 outline-none focus:ring-2 focus:ring-amber-200"
                  [ngModel]="block.bodyTh" (ngModelChange)="patchBlock(i, { bodyTh: $event })" [ngModelOptions]="{ standalone: true }" />
              </div>
            </div>
          </ng-container>
        </div>

        <div *ngIf="!draft().blocks.length"
          class="rounded-2xl border border-dashed border-slate-200 dark:border-slate-700 py-12 text-center text-slate-400">
          <span class="material-icons text-3xl mb-2 opacity-40 block">view_agenda</span>
          <p class="font-bold">ยังไม่มีบล็อก</p>
          <p class="text-xs mt-1">กดปุ่มด้านบนเพื่อเพิ่มข้อความ / รูป / YouTube</p>
        </div>
      </section>
    </div>
  </ng-container>

  <!-- CONTACT -->
  <ng-container *ngIf="viewMode() === 'contact'">
    <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
      <div>
        <button type="button" (click)="backToList()"
          class="mb-2 inline-flex items-center gap-1 text-xs font-bold text-slate-400 hover:text-amber-600 transition-colors cursor-pointer bg-transparent border-0 px-0">
          <span class="material-icons text-[16px]">arrow_back</span>
          กลับรายการ
        </button>
        <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight flex items-center gap-3">
          <span class="w-11 h-11 rounded-2xl bg-gradient-to-br from-amber-400 to-amber-500 text-slate-900 inline-flex items-center justify-center shadow-[0_8px_20px_-6px_rgba(251,191,36,0.55)]">
            <span class="material-icons">support_agent</span>
          </span>
          แจ้งปัญหา / ติดต่อ
        </h1>
        <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
          ที่อยู่และเบอร์ที่แสดงในหน้า LIFF
          <code class="bg-slate-100 dark:bg-slate-800 px-1.5 py-0.5 rounded text-xs">/manual/report</code>
        </p>
      </div>
      <div class="flex flex-wrap items-center gap-3 self-start md:self-end">
        <button type="button" (click)="backToList()" [disabled]="isSaving()"
          class="px-5 h-[46px] bg-white/95 dark:bg-slate-800/95 text-slate-600 dark:text-slate-300 font-bold rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:bg-slate-50 transition-all disabled:opacity-40">
          ยกเลิก
        </button>
        <button type="button" (click)="onSaveContact()" [disabled]="isSaving() || isLoading()"
          class="px-6 h-[46px] bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold rounded-2xl shadow-lg shadow-amber-200/50 dark:shadow-none border-none flex items-center gap-2 disabled:opacity-40 cursor-pointer">
          <span class="material-icons text-[18px]">{{ isSaving() ? 'hourglass_top' : 'save' }}</span>
          {{ isSaving() ? 'กำลังบันทึก...' : 'บันทึก' }}
        </button>
      </div>
    </div>

    <section class="animate-fade-in bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-xl border border-slate-100/50 dark:border-slate-700 p-6 md:p-8 space-y-5">
      <div class="rounded-xl border border-sky-200 bg-sky-50/70 dark:bg-sky-950/20 p-3 text-sm text-sky-900 dark:text-sky-100">
        ข้อมูลนี้แสดงในหน้าแจ้งปัญหาบน LIFF — กรอกชื่อบริษัท ที่อยู่ และเบอร์ติดต่อให้ครบ
      </div>

      <h2 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">business</span>
        ข้อมูลติดต่อ
      </h2>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="md:col-span-2">
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ชื่อบริษัท</label>
          <input
            class="w-full h-[46px] px-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium outline-none focus:ring-2 focus:ring-amber-200"
            [ngModel]="contact().companyNameTh" (ngModelChange)="patchContact({ companyNameTh: $event })" [ngModelOptions]="{ standalone: true }" />
        </div>
        <div class="md:col-span-2">
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ที่อยู่</label>
          <textarea rows="3"
            class="w-full px-4 py-2.5 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm outline-none focus:ring-2 focus:ring-amber-200 resize-none"
            [ngModel]="contact().addressTh" (ngModelChange)="patchContact({ addressTh: $event })" [ngModelOptions]="{ standalone: true }"></textarea>
        </div>
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">เบอร์โทรหลัก</label>
          <input
            class="w-full h-[46px] px-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium outline-none focus:ring-2 focus:ring-amber-200"
            [ngModel]="contact().phone" (ngModelChange)="patchContact({ phone: $event })" [ngModelOptions]="{ standalone: true }"
            placeholder="02-xxx-xxxx" />
        </div>
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">เบอร์สำรอง</label>
          <input
            class="w-full h-[46px] px-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium outline-none focus:ring-2 focus:ring-amber-200"
            [ngModel]="contact().phoneSecondary" (ngModelChange)="patchContact({ phoneSecondary: $event })" [ngModelOptions]="{ standalone: true }" />
        </div>
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">อีเมล</label>
          <input
            class="w-full h-[46px] px-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium outline-none focus:ring-2 focus:ring-amber-200"
            [ngModel]="contact().email" (ngModelChange)="patchContact({ email: $event })" [ngModelOptions]="{ standalone: true }" />
        </div>
        <div class="flex items-end pb-2">
          <label class="inline-flex items-center gap-2 cursor-pointer select-none">
            <input type="checkbox" class="rounded border-slate-300 text-amber-500 focus:ring-amber-400"
              [ngModel]="contact().isActive" (ngModelChange)="patchContact({ isActive: $event })" [ngModelOptions]="{ standalone: true }" />
            <span class="font-bold text-slate-700 dark:text-slate-200">แสดงบน /manual/report</span>
          </label>
        </div>
        <div class="md:col-span-2">
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">หมายเหตุ</label>
          <textarea rows="2"
            class="w-full px-4 py-2.5 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm outline-none focus:ring-2 focus:ring-amber-200 resize-none"
            [ngModel]="contact().noteTh" (ngModelChange)="patchContact({ noteTh: $event })" [ngModelOptions]="{ standalone: true }"></textarea>
        </div>
      </div>
    </section>
  </ng-container>
</div>

<app-pss-loading *ngIf="isLoading() || isSaving()"></app-pss-loading>

<div *ngIf="showImageModal"
  class="fixed inset-0 z-[99999] flex items-center justify-center bg-slate-900/80 backdrop-blur-sm p-4"
  (click)="closeImageModal()">
  <button type="button" class="absolute top-4 right-4 text-white hover:text-amber-400 transition-colors z-[10000]"
    (click)="closeImageModal()">
    <span class="material-icons text-4xl">close</span>
  </button>
  <div class="relative max-w-[90vw] max-h-[90vh] overflow-hidden rounded-2xl shadow-2xl border border-white/10"
    (click)="$event.stopPropagation()">
    <img [src]="selectedImageUrl" alt="" class="object-contain max-w-full max-h-[90vh]">
  </div>
</div>

<app-pss-confirm-modal
  *ngIf="isDeleteConfirmOpen()"
  title="ยืนยันการลบคู่มือ?"
  message="ต้องการลบคู่มือ"
  [highlight]="deleteTarget()?.titleTh || ''"
  messageSuffix="หรือไม่"
  confirmLabel="ลบคู่มือ"
  icon="delete_forever"
  variant="danger"
  [loading]="isSaving()"
  (confirm)="confirmDelete()"
  (cancel)="closeDeleteConfirm()">
</app-pss-confirm-modal>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory"
  [entityType]="activityEntityTypes.PublicGuide"
  [entityId]="draft().id"
  [subtitle]="draft().titleTh"
  (close)="showActivityHistory = false">
</app-modal-admin-activity-history>
